import React, { useId } from 'react'
import { Box } from '@mui/material'
import { tourActionsSx, tourBodySx, tourCardSx, tourCenterSx, tourIconTileSx, tourTitleSx } from './platformTourStyles'

interface PlatformTourCardProps {
  icon: React.ReactNode
  title: string
  body: string
  /** The card's buttons, primary first. */
  children: React.ReactNode
}

/** A card in the middle of the dimmed page, opening and closing the tour. */
export const PlatformTourCard: React.FC<PlatformTourCardProps> = ({ icon, title, body, children }) => {
  const titleId = useId()

  return (
    <Box sx={tourCenterSx}>
      <Box role="dialog" aria-modal aria-labelledby={titleId} sx={tourCardSx}>
        <Box sx={tourIconTileSx} aria-hidden>
          {icon}
        </Box>
        <Box component="h2" id={titleId} sx={tourTitleSx}>
          {title}
        </Box>
        <Box sx={tourBodySx}>{body}</Box>
        <Box sx={tourActionsSx}>{children}</Box>
      </Box>
    </Box>
  )
}
